export default {
  statTotal: 'Subscribed companies',
  statMonthNew: 'New this month',
  statPlaceholder: 'Coming soon',
  tabAll: 'All members',
  tabNormal: 'Standard',
  tabGold: 'Gold',
  tabCustom: 'Custom',
  tabCustomMember: 'Custom Members',
  searchPlaceholder: 'Search company / contact / phone',
  expireAll: 'Expiry: all',
  expireSoon30: 'Expires in 30 days',
  expireSoon90: 'Expires in 90 days',
  expireExpired: 'Expired',
  colMemberNo: 'Member ID',
  colCompany: 'Company / organization',
  colContact: 'Contact',
  colPhone: 'Phone',
  colPlan: 'Current plan',
  colExpire: 'Expires',
  colActivities: 'Events',
  viewDetail: 'Details',
  adjustPlan: 'Change plan',
  permanent: 'Permanent',
  grantTitle: 'Change plan',
  grantHint: 'Grant or replace the plan for “{name}” (no payment, takes effect immediately).',
  grantPick: 'Select a plan',
  grantConfirm: 'Confirm',
  grantSuccess: 'Plan updated',
  crumbPrefix: 'You are here: ',
  basicInfo: 'Basic info',
  registerSource: 'Source',
  sourceAdmin: 'Admin grant',
  sourcePurchase: 'Self-serve purchase',
  sourceFallback: 'Fell back after expiry',
  sourceUnknown: 'Created in admin',
  activityCount: '{n}'
}
